if (!customElements.get('titb-sale-countdown')) {
  customElements.define(
    'titb-sale-countdown',
    class TitbSaleCountdown extends HTMLElement {
      connectedCallback() {
        this.endDate = new Date(this.dataset.endDate);
        this.hideWhenExpired = this.dataset.hideWhenExpired === 'true';
        this.fields = {
          days: this.querySelector('[data-countdown-days]'),
          hours: this.querySelector('[data-countdown-hours]'),
          minutes: this.querySelector('[data-countdown-minutes]'),
          seconds: this.querySelector('[data-countdown-seconds]'),
        };

        this.update();
        this.interval = window.setInterval(() => this.update(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);
      }

      update() {
        if (Number.isNaN(this.endDate.getTime())) {
          window.clearInterval(this.interval);
          return;
        }

        const remaining = Math.max(0, this.endDate.getTime() - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);
        const values = {
          days: Math.floor(totalSeconds / 86400),
          hours: Math.floor((totalSeconds % 86400) / 3600),
          minutes: Math.floor((totalSeconds % 3600) / 60),
          seconds: totalSeconds % 60,
        };

        Object.entries(values).forEach(([key, value]) => {
          if (this.fields[key]) this.fields[key].textContent = String(value).padStart(2, '0');
        });

        if (remaining === 0) {
          window.clearInterval(this.interval);
          if (this.hideWhenExpired && !window.Shopify?.designMode) this.hidden = true;
        }
      }
    }
  );
}
